// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__x87VM {
  background: white;
  border-radius: 5px;
  margin: 0 1rem;
  max-height: 83vh;
  padding: 1rem;
}

.styles_status_container__HZUPs {
  align-items: center;
  display: flex;
  justify-content: center;
}

.styles_ativo_sim__YpkhX {
  background-color: #2e7d32;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_ativo_nao__oXwZg {
  background-color: #9e9e9e;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContasResultado/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf","sourcesContent":[".container {\n  background: white;\n  border-radius: 5px;\n  margin: 0 1rem;\n  max-height: 83vh;\n  padding: 1rem;\n}\n\n.status_container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.ativo_sim {\n  background-color: #2e7d32;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.ativo_nao {\n  background-color: #9e9e9e;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__x87VM`,
	"status_container": `styles_status_container__HZUPs`,
	"ativo_sim": `styles_ativo_sim__YpkhX`,
	"ativo_nao": `styles_ativo_nao__oXwZg`
};
export default ___CSS_LOADER_EXPORT___;
